import { z } from 'zod';
/**
 * Billing settings — pricing tier, payment status, and the current
 * Stripe Customer Portal URL. Per-company pricing (not per-seat) so
 * the leadership team sees the same picture without throttling.
 *
 * Tier names match the marketing site:
 *   - `Seedling`  — $1.2k/mo, 5–25 ppl
 *   - `Operator`  — $3.4k/mo, 25–75 ppl (featured)
 *   - `Compound`  — custom, 75–150 ppl
 *
 * The Customer Portal URL is short-lived (issued by Stripe per session);
 * the `<SettingRow value>` primitive renders it as a "Manage billing →"
 * action. The `POST /api/orgs/:o/billing/portal-session` endpoint lands
 * with epic #16.
 */
export const BillingTier = z.enum(['Seedling', 'Operator', 'Compound']);
export const BillingStatus = z.enum([
    'trialing',
    'active',
    'past_due',
    'cancelled',
]);
export const BillingSettings = z.object({
    tier: BillingTier,
    status: BillingStatus,
    /** ISO timestamp of the next renewal. */
    renewsAt: z.string().optional(),
    /** Last-4 of the card on file (display only). */
    cardLast4: z.string().length(4).optional(),
    /**
     * Stripe Customer Portal session URL. Short-lived; the client should
     * call the portal-session endpoint each time it surfaces "Manage billing"
     * rather than caching this value.
     */
    portalUrl: z.string().optional(),
});
